module.exports = __webpack_public_path__ + "static/media/lightning.7f1b0faf.svg";